// Импортируем другие js-файлы
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;
    for (var i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}
function adjustHeightToMax(selector) {
  var mainDivs = document.querySelectorAll(selector);
  var maxHeight = 0;

 for (var i = 0; i < mainDivs.length; ++i) {
  mainDivs[i].removeAttribute("style");
 }

  for (var i = 0; i < mainDivs.length; ++i) {
    if (maxHeight < mainDivs[i].clientHeight) {
      maxHeight = mainDivs[i].clientHeight;
    }
  }

  for (var i = 0; i < mainDivs.length; ++i) {
    mainDivs[i].style.height = maxHeight + "px";
  }

}

window.onload = function() {
 launchHeight();
};

  window.addEventListener("resize", resizeThrottler, false);

  var resizeTimeout;
  function resizeThrottler() {
    // ignore resize events as long as an actualResizeHandler execution is in the queue
    if ( !resizeTimeout ) {
      resizeTimeout = setTimeout(function() {
        resizeTimeout = null;
  launchHeight();

       // The actualResizeHandler will execute at a rate of 15fps
       }, 66);
    }
  }

  function launchHeight() {
    //adjustHeightToMax(".our-projects__info");
    adjustHeightToMax(".news-block__info");
    adjustHeightToMax(".listnews__info");
    adjustHeightToMax(".projects-list__item");
    adjustHeightToMax(".simple-blocks__item");
    adjustHeightToMax(".tariffs__item");
    adjustHeightToMax(".tariffs__title");
    adjustHeightToMax(".tariffs__place");
    adjustHeightToMax(".love-us__txt");
adjustHeightToMax(".news-block__txt");
  }
svg4everybody();
$(function () {
	var sidebar = $('div#sidebar'), loadedElements = 0;

	$('.lazy').lazy({
		beforeLoad: function (element) {
			console.log('image "' + element.data('src') + '" is about to be loaded');
		},
		afterLoad: function (element) {
			loadedElements++;
			console.log('image "' + element.data('src') + '" was loaded successfully');
		},
		onError: function (element) {
			loadedElements++;
			console.log('image "' + element.data('src') + '" could not be loaded');
		},
		onFinishedAll: function () {
			console.log('finished loading ' + loadedElements + ' elements');
			console.log('lazy instance is about to be destroyed')
		}
	});
});
function applyOFI(forced, viaUrl) {
  objectFitImages(false, {
    watchMQ: true,
    skipTest: forced
  });
}

var yes = "natively supported by this browser";
var no = "not natively supported by this browser";
var testImg = new Image();

if (!("object-fit" in testImg.style) || !("object-position" in testImg.style)) {
  console.log(no);
  applyOFI(true, true);
} else {
  console.log(yes);
}
var scrollers = [];

document.addEventListener("DOMContentLoaded", initMiniScrollbar);

function initMiniScrollbar() {
  MiniBarOptions = {
    alwaysShowBars: true,
    barType: "progress",
  };

  [].slice.call(document.querySelectorAll(".inner")).forEach((el, i) => {
    scrollers.push(
      new MiniBar(el, {
        alwaysShowBars: "visible" in el.dataset,
        barType: i === 5 ? "progress" : "default",
      })
    );
  });
}

function updateScroll(subject) {

  scrollers.forEach(function (el) {
    el["update"]();
  });

}
!(function (e) {
  "function" != typeof e.matches &&
    (e.matches =
      e.msMatchesSelector ||
      e.mozMatchesSelector ||
      e.webkitMatchesSelector ||
      function (e) {
        for (
          var t = this,
          o = (t.document || t.ownerDocument).querySelectorAll(e),
          n = 0;
          o[n] && o[n] !== t;

        )
          ++n;
        return Boolean(o[n]);
      }),
    "function" != typeof e.closest &&
    (e.closest = function (e) {
      for (var t = this; t && 1 === t.nodeType;) {
        if (t.matches(e)) return t;
        t = t.parentNode;
      }
      return null;
    });
})(window.Element.prototype);

document.addEventListener("DOMContentLoaded", function () {
  /* Записываем в переменные массив элементов-кнопок и подложку.
      Подложке зададим id, чтобы не влиять на другие элементы с классом overlay*/
  var modalButtons = document.querySelectorAll(".js-open-modal"),
    overlay = document.querySelector(".js-overlay-modal"),
    closeButtons = document.querySelectorAll(".js-modal-close"),
    body = document.body;

  /* Перебираем массив кнопок */
  modalButtons.forEach(function (item) {
    /* Назначаем каждой кнопке обработчик клика */
    item.addEventListener("click", function (e) {
      /* Предотвращаем стандартное действие элемента. Так как кнопку разные
            люди могут сделать по-разному. Кто-то сделает ссылку, кто-то кнопку.
            Нужно подстраховаться. */
      e.preventDefault();

      /* При каждом клике на кнопку мы будем забирать содержимое атрибута data-modal
            и будем искать модальное окно с таким же атрибутом. */
      var modalId = this.getAttribute("data-modal"),
        modalElem = document.querySelector(
          '.modal[data-modal="' + modalId + '"]'
        );

      /* После того как нашли нужное модальное окно, добавим классы
            подложке и окну чтобы показать их. */
      modalElem.classList.add("active");
      updateScroll(".inner");
      overlay.classList.add("active");
      body.classList.add('stop');
    }); // end click
  }); // end foreach

  closeButtons.forEach(function (item) {
    item.addEventListener("click", function (e) {
      var parentModal = this.closest(".modal");

      parentModal.classList.remove("active");
      overlay.classList.remove("active");
      body.classList.remove('stop');

      reloadForm();


    });
  }); // end foreach 

  document.body.addEventListener(
    "keyup",
    function (e) {
      var key = e.keyCode;

      if (key == 27) {
        document.querySelector(".modal.active").classList.remove("active");
        document.querySelector(".overlay").classList.remove("active");
        body.classList.remove('stop');

        reloadForm();
      }
    },
    false
  );

  overlay.addEventListener("click", function () {
    document.querySelector(".modal.active").classList.remove("active");
    this.classList.remove("active");
    body.classList.remove('stop');

    reloadForm();



  });

  function reloadForm() {
    var elems = document.querySelectorAll(".connection.processedForm");

    [].forEach.call(elems, function (el) {
      el.classList.remove("processedForm");
      el.removeAttribute('style');
    });

    var thanks = document.querySelectorAll(".connection + .thank");
    [].forEach.call(thanks, function (el) {
      el.removeAttribute('style');
    });
  }

}); // end ready
"use strict";

document.addEventListener("DOMContentLoaded", function (event) {
  var onTransitionEnd = function (event) {
    var body = document.body,
      page = document.getElementById("page-wrapper");

    if (this != event.target) return;

    body.classList.remove("animating");
    body.classList.remove("left");
    body.classList.remove("right");
    body.classList.remove('stop');

    body.classList.toggle("menu-visible");

    page.transitionend = page.webkitTransitionEnd = page.otransitionend = page.MSTransitionEnd = null;
  };



  // Run if toggle menu button was tapped or clicked
  document
    .getElementById("mobile-menu-toggle")
    .addEventListener("click", function (e) {
      e.preventDefault();

      var body = document.body,
        page = document.getElementById("mobile-menu");

      // When the toggle menu link is clicked, animation starts
      page.classList.add("animating");
      updateScroll(".inner");
      // Set direction of the animation
      // body.classList.add(
      //   body.classList.contains("menu-visible") ? "right" : "left"
      // );
      body.classList.add('stop');
      // add event listeners for transition end event

      // if (page.addEventListener) {

      //   page.addEventListener("transitionend", onTransitionEnd, false);
      //   page.addEventListener(
      //     "webkitTransitionEnd",
      //     onTransitionEnd,
      //     false
      //   );
      //   page.addEventListener(
      //     "otransitionend",
      //     onTransitionEnd,
      //     false
      //   );
      //   page.addEventListener(
      //     "MSTransitionEnd",
      //     onTransitionEnd,
      //     false
      //   );
      // } else {
      //   // page.attachEvent("transitionend", onTransitionEnd);
      //   // page.attachEvent("webkitTransitionEnd", onTransitionEnd);
      //   // page.attachEvent("otransitionend", onTransitionEnd);
      //   // page.attachEvent("MSTransitionEnd", onTransitionEnd);
      // }
    });

  document
    .getElementById("mobile-menu-close")
    .addEventListener("click", function (e) {
      e.preventDefault();
      var body = document.body,
        page = document.getElementById("mobile-menu");
      console.log('close');
      // When the toggle menu link is clicked, animation starts
      page.classList.remove("animating");
      body.classList.remove('stop');
      // Set direction of the animation
      // body.classList.add(
      //   body.classList.contains("menu-visible") ? "right" : "left"
      // );
    });



});
// =================  tabs.js  =====================

function changing_img(lnk) {
var currentBlock = $(lnk).attr('rel'),
imgPlan = $("#tab" + currentBlock)
    .find(".tabs-plans__img--inner")
    .attr("data-url");
$('#plan-img').css("background-image", "url('" + imgPlan + "')");
}

$(document).ready(function() {
  function enumeration(el) {
    var ordinal = 1;
    $(el).each(function(indx) {
      $(this).attr("rel", ordinal++);
    });
  }

  enumeration(".tab_content");
  enumeration("ul.tabs li");
  enumeration(".tab_accordion");

  var ordinalID = 1;
  $(".tab_content").each(function(indx) {
    $(this).attr("id", "tab" + ordinalID++);
  });

  $(".tab_content").hide();
  $(".tab_content:last").show();
  $(".tab_accordion:last").addClass("d_active");
  $(".tabs li:last").addClass("active");

  /* в режиме вкладок */
  $("ul.tabs li").click(function(e) {
    var $link = $(e.target);
    e.preventDefault();
    if (!$link.data("lockedAt") || +new Date() - $link.data("lockedAt") > 300) {
      $(".tab_content").hide();
      var activeTab = $(this).attr("rel");

      $("#tab" + activeTab).fadeIn();
      $("ul.tabs li").removeClass("active");
      $(this).addClass("active");
      $(".tab_accordion").removeClass("d_active");
      $(".tab_accordion[rel^='" + activeTab + "']").addClass("d_active");

      changing_img($link);
    }
    $link.data("lockedAt", +new Date());
  });

  /* в режиме аккордеона */
  $(".tab_accordion").click(function(e) {
    var $link = $(e.target);
    e.preventDefault();
    if (!$link.data("lockedAt") || +new Date() - $link.data("lockedAt") > 300) {
      if (!$(this).hasClass("d_active")) {
        $(".tab_content").hide();
        var d_activeTab = $(this).attr("rel");
        $("#tab" + d_activeTab).fadeIn();
        $(".tab_accordion").removeClass("d_active");
        $(this).addClass("d_active");
        $("ul.tabs li").removeClass("active");
        $("ul.tabs li[rel^='" + d_activeTab + "']").addClass("active");


      } else {
        $(this).removeClass("d_active");
        $(".tab_content").hide();
        $("#tab" + d_activeTab).fadeIn();
        $(".tab_accordion").removeClass("d_active");
        $("ul.tabs li").removeClass("active");
        $("ul.tabs li[rel='1']").addClass("active");
       }
    }
    $link.data("lockedAt", +new Date());
  });
  /* дополнительный класс tab_last,
    чтобы добавить границу к правой
    стороне последней вкладки. */
  $("ul.tabs li")
    .last()
    .addClass("tab_last");


});

// ================= end ==== tabs.js  =====================
if ($(".fancybox").length) {
  $(".fancybox").fancybox({
    openEffect: "none",
    closeEffect: "none"
  });
}

var swiper = new Swiper(".main-screen__slider", {
    pagination: {
        el: ".swiper-pagination",
        dynamicBullets: true, clickable: true,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        // when window width is >= 320px
        320: {
            navigation: false
        },
        // when window width is >= 480px
        480: {

        },
        // when window width is >= 640px
        640: {

        }
    }
});

var swiper = new Swiper(".review__slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    initialSlide: 2,
    centeredSlides: true,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
        dynamicBullets: true,
    },
    breakpoints: {
        // when window width is >= 320px
        320: {
            // navigation: false
        },
        // when window width is >= 480px
        768: {
            slidesPerView: 2,
        },
        // when window width is >= 640px
        1200: {
            slidesPerView: 3,

        }
    }
});

var swiper = new Swiper(".photos__slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    initialSlide: 2,
    centeredSlides: true,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
        dynamicBullets: true,
    },
    breakpoints: {
        // when window width is >= 320px
        320: {
            // navigation: false
        },
        // when window width is >= 480px
        768: {
            slidesPerView: 2,
        },
        // when window width is >= 640px
        1200: {
            slidesPerView: 3,

        }
    }
});

var swiper = new Swiper(".tech__slider", {
    pagination: {
        el: ".swiper-pagination",
        dynamicBullets: true, clickable: true,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        // when window width is >= 320px
        320: {
            navigation: false
        },
        // when window width is >= 480px
        480: {

        },
        // when window width is >= 640px
        640: {

        }
    }
});

var swiper = new Swiper(".order__slider", {
    pagination: {
        el: ".swiper-pagination",
        dynamicBullets: true, clickable: true,
    },
    navigation: {
        nextEl: '.order__slider__arrow--right',
        prevEl: '.order__slider__arrow--left',
    },
    breakpoints: {
        // when window width is >= 320px
        320: {
            navigation: false
        },
        // when window width is >= 480px
        480: {

        },
        // when window width is >= 640px
        640: {

        }
    }
});
function initFancy(){

if ($(".fancybox").length) {

  $(".fancybox").fancybox({
    openEffect: "none",
    closeEffect: "none",
    beforeShow: function () {
      // document.querySelector(".modal").classList.remove("active");
      // document.querySelector(".overlay").classList.remove("active");
    },
    afterShow: function () {

    },
    iframe: {
      preload: true,
      css: {
        width: "1810px",
      },
    },
  });

}

if ($(".fancy-project").length) {

  $(".fancy-project").fancybox({
    openEffect: "none",
    closeEffect: "none",
    baseClass: "project-container",
    afterShow: function () {},
    iframe: {
      preload: true,
      css: {
        width: "1570px",
      },
    },
  });
}


if ($(".fancy-pdf").length) {
  $(".fancy-pdf").fancybox({
    baseClass: "fancybox-custom-layout",
    infobar: false,
    touch: {
      vertical: false,
    },
    buttons: ["close", "thumbs", "share"],
    animationEffect: "fade",
    transitionEffect: "fade",
    preventCaptionOverlap: false,
    idleTime: false,
    gutter: 0,
    // Customize caption area
    // caption: function (instance) {
    //   return '<h3>home</h3><p>interiors, exteriors, and the humans that inhabit them.</p><p><a href="https://unsplash.com/collections/curated/162" target="_blank">unsplash.com</a></p>';
    // },
  });
}



if ($('[data-fancybox="inlines"]').length) {
  $('[data-fancybox="inlines"]').fancybox({
    openEffect: "none",
    closeEffect: "none",
    smallBtn: "true",
    baseClass: "inline-container",
    buttons: [
      // "zoom",
      //"share",
      // "slideShow",
      //"fullScreen",
      //"download",
      // "thumbs",
      "close",
    ],
    btnTpl: {
      smallBtn:
        '<svg data-fancybox-close  class="inner__cross" title="{{CLOSE}}" width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg" fill="none"><path d="M25.611 4.39c-5.853-5.852-15.371-5.852-21.224 0-5.85 5.851-5.85 15.372 0 21.224 2.926 2.925 6.769 4.387 10.613 4.387 3.843 0 7.685-1.462 10.611-4.387 5.852-5.852 5.852-15.372 0-21.224zm-4.422 15.033c.489.489.489 1.279 0 1.768-.244.244-.564.366-.884.366-.32 0-.64-.123-.884-.366l-4.421-4.422-4.42 4.421c-.245.244-.565.367-.884.367-.32 0-.64-.123-.884-.367-.489-.489-.489-1.281 0-1.768l4.42-4.421-4.421-4.421c-.489-.489-.489-1.281 0-1.768.488-.489 1.279-.489 1.768 0l4.421 4.421 4.421-4.421c.489-.489 1.279-.489 1.768 0 .489.488.489 1.279 0 1.768l-4.421 4.421 4.421 4.422z" fill="#C4C4C4" clip-path="url(#a)"></path><defs><clipPath id="a">     <path fill="#fff" d="M0 0h30v30h-30z"></path></clipPath></defs></svg>',
      // Arrows
      arrowLeft:
        '<svg  data-fancybox-prev title="{{PREV}}"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 292.7 292.7" ><path fill="#C4C4C4"  d="M266.9,272.4H26.4c-3.1,0-5.7-2.6-5.7-5.7V26.3c0-3.1,2.6-5.7,5.7-5.7h240.5c3.1,0,5.7,2.6,5.7,5.7v240.5C272.6,269.9,270,272.4,266.9,272.4z"/><path fill="#FFFFFF" d="M216.2,134.8h-117l32.7-44.7c1.8-2.4,2.5-5.3,2-8.3c-0.5-2.9-2.1-5.5-4.5-7.3c-1.9-1.4-4.2-2.1-6.5-2.1c-3.6,0-7,1.7-9.1,4.7l-45.7,62.8c-0.1,0.1-0.1,0.2-0.2,0.3c-0.3,0.4-0.5,0.8-0.8,1.3c0,0,0,0.1-0.1,0.1c-0.5,1-0.8,2.1-1,3.3c-0.1,0.6-0.1,1.2-0.1,1.7c0,0.5,0,1.1,0.1,1.8c0.2,1.1,0.5,2.3,1.1,3.3c0.3,0.5,0.5,1,0.8,1.4c0,0,0.1,0.1,0.1,0.1l45.7,62.8c2.1,2.9,5.5,4.6,9.1,4.6c2.4,0,4.7-0.7,6.6-2.1c2.4-1.8,4-4.4,4.5-7.3c0.5-2.9-0.3-5.8-2-8.2l-32.7-44.7h117c6.1,0,11.2-5.4,11.2-11.7C227.4,140.2,222.3,134.8,216.2,134.8z"/><path fill="#FFFFFF" d="M216.2,153H94.1c-1,0-1.9,0.6-2.3,1.4c-0.4,0.9-0.4,1.9,0.2,2.7l35.7,48.9c0.9,1.3,1.3,2.8,1.1,4.3c-0.2,1.5-1.1,2.9-2.4,3.9c-1,0.7-2.3,1.1-3.5,1.1c-2,0-3.7-0.9-4.9-2.5l-45.6-62.7c0,0,0-0.1-0.1-0.1c-0.2-0.3-0.3-0.5-0.5-0.8c-0.3-0.5-0.5-1.1-0.6-1.8c-0.1-0.4-0.1-0.6-0.1-0.9s0-0.6,0.1-1c0.1-0.6,0.3-1.2,0.6-1.8c0,0,0,0,0,0c0.1-0.3,0.3-0.5,0.5-0.7c0-0.1,0.1-0.1,0.1-0.2L118,80.1c1.1-1.6,3-2.5,4.9-2.5c1.3,0,2.5,0.4,3.5,1.1c1.3,1,2.2,2.3,2.4,3.9c0.2,1.5-0.1,3.1-1.1,4.4L92,135.9c-0.6,0.8-0.7,1.8-0.2,2.7c0.4,0.9,1.3,1.4,2.3,1.4h122.1c3.2,0,6,3,6,6.5S219.4,153,216.2,153z"/></svg>',

      arrowRight:
        '<svg data-fancybox-next title="{{NEXT}}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 292.7 292.7" ><path fill="#C4C4C4"  d="M266.9,272.4H26.4c-3.1,0-5.7-2.6-5.7-5.7V26.3c0-3.1,2.6-5.7,5.7-5.7h240.5c3.1,0,5.7,2.6,5.7,5.7v240.5C272.6,269.9,270,272.4,266.9,272.4z"/><path fill="#FFFFFF" d="M61.1,146.5c0,6.4,5.1,11.7,11.2,11.7h117L156.6,203c-1.8,2.4-2.5,5.3-2,8.2c0.5,2.9,2.1,5.5,4.5,7.3c1.9,1.4,4.2,2.1,6.6,2.1c3.6,0,7-1.7,9.1-4.6l45.7-62.8c0,0,0.1-0.1,0.1-0.1c0.3-0.4,0.6-0.9,0.8-1.4c0.5-1.1,0.9-2.2,1.1-3.3c0.1-0.7,0.1-1.2,0.1-1.8c0-0.5,0-1.1-0.1-1.7c-0.2-1.2-0.5-2.3-1-3.3c0,0,0-0.1-0.1-0.1c-0.2-0.4-0.5-0.9-0.8-1.3c-0.1-0.1-0.1-0.2-0.2-0.3l-45.7-62.8c-2.1-2.9-5.5-4.7-9.1-4.7c-2.4,0-4.6,0.7-6.5,2.1c-2.4,1.8-4,4.4-4.5,7.3c-0.5,2.9,0.3,5.8,2,8.3l32.7,44.7h-117C66.2,134.8,61.1,140.2,61.1,146.5z"/><path fill="#FFFFFF" d="M66.3,146.5c0-3.5,2.8-6.5,6-6.5h122.1c1,0,1.9-0.6,2.3-1.4c0.4-0.9,0.4-1.9-0.2-2.7L160.8,87c-0.9-1.3-1.3-2.8-1.1-4.4c0.2-1.6,1.1-2.9,2.4-3.9c1-0.7,2.2-1.1,3.5-1.1c1.9,0,3.8,0.9,4.9,2.5l45.6,62.7c0,0.1,0.1,0.1,0.1,0.2c0.2,0.2,0.3,0.5,0.5,0.7c0,0,0,0,0,0c0.3,0.6,0.5,1.2,0.6,1.8c0.1,0.4,0.1,0.7,0.1,1s0,0.6-0.1,0.9c-0.1,0.7-0.3,1.2-0.6,1.8c-0.1,0.3-0.3,0.6-0.5,0.8c0,0,0,0.1-0.1,0.1l-45.6,62.7c-1.1,1.6-2.9,2.5-4.9,2.5c-1.3,0-2.5-0.4-3.5-1.1c-1.3-1-2.2-2.3-2.4-3.9c-0.2-1.5,0.1-3,1.1-4.3l35.7-48.9c0.6-0.8,0.7-1.8,0.2-2.7c-0.4-0.9-1.3-1.4-2.3-1.4H72.3C69.1,153,66.3,150,66.3,146.5z"/></svg>',
    },
    beforeShow: function () {
      // document.querySelector(".modal").classList.remove("active");
      // document.querySelector(".overlay").classList.remove("active");
    },
    afterShow: function (instance, slide) {
      // console.log("Current slide options");
      // console.log(slide.opts);
      // console.log(slide.$slide);

      launchHeight();
    },
    onActivate: function () {},
    iframe: {
      preload: true,
      css: {
        width: "1810px",
      },
    },
  });
}

}




window.addEventListener("load", function () {
  initFancy();
});
// requiere moment.js
// requiere bootstrap
// requiere jquery
// requiere calendar.css
// autor: Yordanch Vargas Velasque
// email: snd.yvv@gmail.com

moment.locale("en");
class CalendarYvv {
	constructor(etiqueta = "", diaSeleccionado = "", primerDia = "Lunes") {
		this.etiqueta = etiqueta; // etiqueta donde se mostrará
		this.primerDia = primerDia; // inicio de la semana
		this.diaSeleccionado = diaSeleccionado == "" ? moment().format("Y-M-D") : diaSeleccionado; // día actual seleccionado

		this.funcPer = function (e) { }; // funcion a ejecutar al lanzar el evento click
		this.funcNext = false; // funcion a ejecutar al lanzar el evento click
		this.funcPrev = false; // funcion a ejecutar al lanzar el evento click
		this.currentSelected = moment().format("Y-M-D"); // elemento seleccionado

		this.diasResal = []; // dias importantes
		this.colorResal = ""; // color de los dias importantes
		this.textResalt = ""; // color de texto de dias importantes

		this.bg = ""; // color de fondo de la cabecera
		this.textColor = ""; // color de texto en la cabecera
		this.btnH = ""; // color de boton normal
		this.btnD = "";// color de boton al pasar el mouse - "btn-outline-dark";

		this.__author = "Yordanch Vargas Velasque";
		this.__email = "snd.yvv@gmail.com";
		this.__version = "1.1.1";
	}
	startElements() {
		this.diaSeleccionado = this.corregirMesA(this.diaSeleccionado);
		this.inicioDia = moment(this.diaSeleccionado).format("dddd"); // inicio dia del mes
		this.mesSeleccionado = this.diaSeleccionado.split("-")[1] * 1; // mes seleccionado
		this.anioSeleccionado = this.diaSeleccionado.split("-")[0] * 1; // año seleccionado
		this.cantDias = moment(this.diaSeleccionado).daysInMonth() * 1; // cantidad de dias del mes
		this.diasCoto = ["пн", "вт", "ср", "чт", "пт", "сб", "вс"];
		this.diasLargo = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
	}
	createCalendar() {
		this.startElements();
		var cont = $(this.etiqueta);
		var cntCale = $("<div class='calendar-yvv w-100'>");
		var headerCalendar = this.createHeaderM();
		var daysLettCalendar = this.createDayTag();
		var daysNumCalendar = this.createDaysMont();

		cont.html("");
		cntCale.append(headerCalendar);
		cntCale.append(daysLettCalendar);
		cntCale.append(daysNumCalendar);
		cont.append(cntCale);
	}
	createHeaderM() {
		var cont = $("<div class='calendar__header " + this.bg + " " + this.textColor + "'>");
		var arrowL = $("<span class='calendar__arrow " + this.btnH + "'>").html("<svg class='calendar__arrow__svg'><use xlink:href='/img/sprite.svg#arrow--left'></use></svg>");
		var arrowR = $("<span class='calendar__arrow  " + this.btnH + "'>").html("<svg class='calendar__arrow__svg'><use xlink:href='/img/sprite.svg#arrow--right'></use></svg>");
		var title = $("<span class='calendar__header__title'>").html(moment(this.diaSeleccionado).format("MMMM - Y"));
		var _this = this;

		arrowL.on("click", function (e) {
			_this.mesAnterior(_this)
		});
		arrowR.on("click", function (e) {
			_this.mesSiguiente(_this)
		});
		cont.append(arrowL);
		cont.append(title);
		cont.append(arrowR);
		return cont;
	}
	createDayTag() {
		var newPrimerDia = this.firtsMayus(this.primerDia);
		var diasOrd = this.ordenarDiasMes(newPrimerDia);

		var cont = $("<div class='calendar__line d-flex justify-content-between" + this.bg + " " + this.textColor + "'>");

		diasOrd.fechCort.forEach(function (e) {
			var div = $("<div class='d-flex calendar__day justify-content-center'>").html(e);
			cont.append(div);
		});
		return cont;
	}
	createDaysMont() {
		var diaSelected = this.corregirMesA(this.anioSeleccionado + "-" + this.mesSeleccionado + "-01");
		var primerDiaMes = moment(diaSelected).format("dddd");
		var diaInicio = this.firtsMayus(primerDiaMes); //this.firtsMayus(this.inicioDia);
		var diasOrd = this.ordenarDiasMes(this.firtsMayus(this.primerDia));
		var posMes = diasOrd.fechLarg.indexOf(diaInicio);

		var cnt = 0;
		var cntG = $("<div class='w-100'>");

		var cont = $("<div class='d-flex  w-100 align-items-center'>");
		var emptyTag = "<div class='d-flex flex-fill w-100 justify-content-center ' style='color:transparent'>";
		for (var j = 0; j < posMes; j++) {
			var div = $(emptyTag).html("0");
			cont.append(div);
			cnt++;
		}
		for (var i = 0; i < this.cantDias; i++) {
			var fechNow = this.anioSeleccionado + "-" + this.mesSeleccionado + "-" + (i + 1);
			var div = $("<div class='d-flex  flex-fill w-100 justify-content-center calendar__date align-items-center " + this.btnD + "' data-date='" + fechNow + "'>").html(i + 1);
			var clas_e = this;
			var _ind = (this.cantDias + posMes) % 7;

			//dia seleccionado
			if (this.diaSeleccionado == fechNow) {
				div = $("<div class='current-date-selected d-flex  flex-fill w-100 justify-content-center " + this.btnD + "' data-date='" + fechNow + "'>").html(i + 1);
			}
			//dias resaltados o importantes
			if (this.diasResal.indexOf(i + 1) != -1) {
				div = $("<div class='d-flex flex-fill w-100 justify-content-center selected align-items-center calendar__date " + this.btnD + "' data-date='" + fechNow + "' style='background: " + this.colorResal + "; color: " + this.textResalt + "; font-weight: bold;'>").html(i + 1);
			}

			div.on("click", function (e) {
				var daySelec = $(e.target).attr("data-date");
				clas_e.currentSelected = daySelec;
				clas_e.funcPer(clas_e)
			});
			cont.append(div);
			if (cnt == 6) {
				//div.on("click", this.funcPer);
				cntG.append(cont);
				cont = $("<div class='d-flex  w-100 '>");
				cnt = 0;
			} else if (this.cantDias == (i + 1)) {
				for (var j = 0; j < (7 - _ind); j++) {
					var div = $(emptyTag).html("0");
					cont.append(div);
					cnt++;
				}
				cntG.append(cont);
				cont = $("<div class='d-flex  w-100 '>");
				cnt = 0;
			} else {
				//cont.append(div);
				cnt++;
			}
		}
		return cntG;
	}
	ordenarDiasMes(dia) {
		var posMes = this.diasLargo.indexOf(dia);
		var fechCort = [];
		var fechLarg = [];

		for (var i = posMes; i < this.diasCoto.length; i++) {
			fechCort.push(this.diasCoto[i]);
			fechLarg.push(this.diasLargo[i]);
		}
		for (var j = 0; j < posMes; j++) {
			fechCort.push(this.diasCoto[j]);
			fechLarg.push(this.diasLargo[j]);
		}
		return { fechCort, fechLarg };
	}
	firtsMayus(letter) {
		var lett = "";
		for (var i = 0; i < letter.length; i++) {
			if (i == 0) lett += "" + letter[i].toUpperCase();
			else lett += "" + letter[i].toLowerCase();
		}
		return lett;
	}
	mesAnterior(ev) {
		ev.mesSeleccionado--;
		if (ev.mesSeleccionado == 0) {
			ev.anioSeleccionado--;
			ev.mesSeleccionado = 12;
		}
		var day = ev.diaSeleccionado.split("-")[2] * 1;
		ev.diaSeleccionado = ev.anioSeleccionado + "-" + ev.mesSeleccionado + "-" + day;
		ev.diaSeleccionado = ev.corregirMesA(ev.diaSeleccionado);
		ev.cantDias = moment(ev.diaSeleccionado).daysInMonth() * 1;
		ev.createCalendar();

		if (this.funcPrev) {
			this.funcPrev(ev)
		} else {
			ev.createCalendar();
		}
	}
	mesSiguiente(ev) {
		ev.mesSeleccionado++;
		if (ev.mesSeleccionado == 13) {
			ev.anioSeleccionado++;
			ev.mesSeleccionado = 1;
		}
		var day = ev.diaSeleccionado.split("-")[2] * 1;
		ev.diaSeleccionado = ev.anioSeleccionado + "-" + ev.mesSeleccionado + "-" + day;
		ev.diaSeleccionado = ev.corregirMesA(ev.diaSeleccionado);
		ev.cantDias = moment(ev.diaSeleccionado).daysInMonth() * 1;

		if (this.funcNext) {
			this.funcNext(ev)
		} else {
			ev.createCalendar();
		}
	}
	corregirMesA(_f) {
		var fec = _f.split("-");
		fec[1] = (fec[1] < 10 && fec[1].length == 1) ? ("0" + fec[1]) : fec[1];
		fec[2] = (fec[2] < 10 && fec[2].length == 1) ? ("0" + fec[2]) : fec[2];
		return fec.join("-");
	}
}
$(document).ready(function (e) {
    calendar = new CalendarYvv("#calendar", moment().format("Y-M-D"), "Monday");
    calendar2 = new CalendarYvv("#calendar2", moment().format("Y-M-D"), "Monday");
    calendar.funcPer = function (ev) {
        console.log(ev)
    };
    calendar.diasResal = [4, 15, 26]
    calendar.createCalendar();
    calendar2.createCalendar();


});
var accordions = document.getElementsByClassName("faq__btn");

for (var i = 0; i < accordions.length; i++) {
    accordions[i].onclick = function () {
        this.classList.toggle('is-open');

        var content = this.nextElementSibling;
        if (content.style.maxHeight) {
            // accordion is currently open, so close it
            content.style.maxHeight = null;
        } else {
            // accordion is currently closed, so open it
            content.style.maxHeight = content.scrollHeight + "px";
        }
    }
}
lazyframe('.lazyframe');